export const countyFormatter = (county: string) => (county ? county.replace("_", ". ") : "");
